module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'ฉันต้องการบันทึกบัตรนี้สำหรับการซื้อในอนาคต',
    cardInfoLabel: '{brand} ลงท้ายด้วย {lastFour}',
    newCreditCardLabel: 'ใช้บัตรเครดิตใบอื่น',
  },
  creditcardButtonMessage: 'ชำระด้วยบัตรเครดิต',
  debitcardButtonMessage: 'ชำระด้วยบัตรเดบิต',
  externalpayproviderButtonMessage: 'ชำระผ่าน Fawry',
  banktransferButtonMessage: 'ชำระด้วยการโอนเงินผ่านธนาคาร',
  cardNumberLabel: 'หมายเลขบัตร',
  methodName: {
    creditcard: 'บัตรเครดิต',
    debitcard: 'บัตรเดบิต',
    externalpayprovider: 'Fawry',
    paymob: 'กระเป๋าเงินมือถือ',
  },
  info: {
    paymob: {
      payButton: 'ชำระด้วยกระเป๋าเงินมือถือ',
      phoneNumber: 'หลังจากยืนยัน คุณจะถูกเปลี่ยนเส้นทางไปยังกระเป๋าเงินของคุณโดยอัตโนมัติ',
      title: 'ชำระเงินได้ง่ายด้วยกระเป๋าเงินมือถือของคุณ!',
      description: 'คุณสามารถชำระเงินโดยใช้กระเป๋าเงินมือถือใดก็ได้ที่ได้รับอนุญาตจากธนาคารกลางแห่งอียิปต์ — เพลิดเพลินกับการทำธุรกรรมที่รวดเร็ว ปลอดภัย และสะดวกสบายจากโทรศัพท์ของคุณ',
    },
  },
};
